import styled from "styled-components";

export const GamePlayPcHeaderBarGameTitleBox = styled.div`
  font-size: 1.8rem;
  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    display: none;
  }
`